export enum TwitterAccessScopeEnum {
  USERS_READ = 'users.read',
  FOLLOWS_READ = 'follows.read',
  FOLLOWS_WRITE = 'follows.write',
  TWEET_READ = 'tweet.read',
  TWEET_WRITE = 'tweet.write',
  OFFLINE_ACCESS = 'offline.access',
  LIKE_READ = 'like.read',
  LIKE_WRITE = 'like.write',
}
